import React from "react";
import { GridRowIdGetter } from "@mui/x-data-grid";
import { GridColDef as GridColDefPro } from "@mui/x-data-grid-pro";
import NzcDataGrid from "components/NzcDataGrid/NzcDataGrid";

type CustomDataGridProps =
  | {
      rows: any[];
      columns: GridColDefPro[];
      pageSizeOptions?: number[];
      getRowId?: GridRowIdGetter<any>;
      totalRow?: never;
    }
  | {
      rows: any[];
      columns: GridColDefPro[];
      pageSizeOptions?: number[];
      getRowId: GridRowIdGetter<any>;
      totalRow: any;
    };

const CustomDataGrid: React.FC<CustomDataGridProps> = ({
  rows,
  columns,
  pageSizeOptions = [5, 10, 15, 20],
  getRowId,
  totalRow,
}) => (
  <NzcDataGrid
    rows={rows}
    columns={columns}
    pagination
    pageSizeOptions={pageSizeOptions}
    getRowId={getRowId}
    disableRowSelectionOnClick
    autoHeight
    pinnedBottomRow={totalRow ? [totalRow] : []}
    sx={{
      "& .MuiDataGrid-columnHeaders": {
        minHeight: "56px !important",
        maxHeight: "fit-content !important",
      },
      "& .MuiDataGrid-columnHeader": {
        height: "auto !important",
        maxHeight: "none !important",
        lineHeight: "normal !important",
        padding: "8px !important",
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        whiteSpace: "normal !important",
        lineHeight: "1.2 !important",
      },
      "& .MuiDataGrid-pinnedRows": {
        fontWeight: 700,
        backgroundColor: "#F8F9FA",
      },
    }}
    checkBoxSelection={false}
    enableFiltering={true}
    quickFilter={true}
    columnVisibility={{
      id: false,
    }}
  />
);

export default CustomDataGrid;